import { IAppConfig } from '../types/app-config.interface';

class AppConfigService {
  private _config: IAppConfig | null = null;

  async load(): Promise<void> {
    try {
      const response = await fetch('/acfg.json');
      if (!response.ok) {
        throw new Error(`Failed to load acfg.json: ${response.statusText}`);
      }
      this._config = await response.json();
      console.log('App Config Loaded:', this._config);
    } catch (error) {
      console.error('Failed to load acfg.json:', error);
      throw new Error('Application configuration failed to load');
    }
  }

  get config(): IAppConfig {
    if (!this._config) {
      throw new Error('AppConfig has not been loaded yet!');
    }
    return this._config;
  }

  get baseUrl(): string {
    return this.config.baseUrl;
  }
}

export default new AppConfigService();
